export default "__VITE_ASSET__IeYt3gabA5Fp77wsKID3Ew__"